export class AxTab {
    private TabHolders: TabHolder[] = [];
    private DefaultSelector: string = '.ax-tabs.ax-tabs--auto';

    Init(selector?: string) {
        selector = selector || this.DefaultSelector;

        if (selector != this.DefaultSelector && $(selector + '[data-ax-tab-header-for]').length == 0) {
            console.log(`AxTab: No Element or Target found for ${selector}`);
        }

        $(selector + '[data-ax-tab-header-for]').each((i, e) => {
            let $e = $(e);
            let startTarget = $e.attr('data-ax-tab-start');

            let holder: TabHolder = {
                Menu: e,
                TabContentHolder: [],
                EventListner: null
            };
            holder.EventListner = AxTabListener.Listener.bind(this, holder);

            let target = $($e.attr('data-ax-tab-header-for'));

            target.children('*[data-target]').each((i, c) => {
                let $c = $(c);
                let targetName = $c.attr('data-target');
                let active = (typeof startTarget != 'undefined' && targetName == startTarget);
                holder.TabContentHolder.push({
                    TargetName: targetName,
                    Active: false, //will be set in Activate Target
                    TargetElement: c
                });

                if (active) {
                    this.ActivateTarget(targetName, holder);
                }
            });

            holder.Menu.addEventListener("click", holder.EventListner);
            this.TabHolders.push(holder);
        });
    }

    ActivateTab(targetName: string) {
        let tabHolders = this.TabHolders.filter(x => x.TabContentHolder.findIndex(y => y.TargetName == targetName) != -1);

        for (let holder of tabHolders) {
            this.ActivateTarget(targetName, holder);
        }
    }

    private ActivateTarget(targetName: string, tabHolder: TabHolder) {
        let $menu = $(tabHolder.Menu);
        $menu.children('*[data-target]').removeClass('active');
        $menu.children(`[data-target=${targetName}]`).addClass('active');

        let currentTarget = tabHolder.TabContentHolder.find(x => x.Active);

        if (typeof currentTarget == 'undefined' || currentTarget.TargetName != targetName) {
            if (typeof currentTarget != 'undefined') {
                currentTarget.Active = false;
                $(currentTarget.TargetElement).removeClass('active');
            }

            let contentTarget = tabHolder.TabContentHolder.find(x => x.TargetName == targetName);
            contentTarget.Active = true;
            $(contentTarget.TargetElement).addClass('active');
        }
    }
}

const AxTabListener = {
    ///Element seems to be null
    Listener(tabHolder: TabHolder, event: PointerEvent) {
        let target = event.target;

        let targetName = $(target).attr('data-target');

        if (typeof targetName != 'undefined') {
            this.ActivateTarget(targetName, tabHolder);
        }
    }
};

interface TabHolder {
    Menu: HTMLElement;
    TabContentHolder: ContentHolder[];
    EventListner: any;
}

interface ContentHolder {
    TargetName: string;
    Active: boolean;
    TargetElement: HTMLElement;
}